import { render } from "./NavigationView.vue?vue&type=template&id=73012bf1&ts=true"
import script from "./NavigationView.vue?vue&type=script&lang=ts"
export * from "./NavigationView.vue?vue&type=script&lang=ts"

import "./NavigationView.vue?vue&type=style&index=0&id=73012bf1&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__